<template>
  <div class="modal-content">
    <div class="modal-body">  
      <div class="row text-center animated fadeInDown">
        <div class="col-lg-12">
          <div class="m-b-md">
            <h2 class="font-bold">Véhicule vendu</h2>
            <p class="m-t-md">Super !</p>
            <div class="m-t-md middle-box">
              <div class="row">
                <div class=" m-b">
                  <div class="m-t">
                    <div class="col-lg-8 col-xs-8 text-left m-b-lg font-bold">Carte grise : démarche effectuée par Feu Vert ?</div>
                    <div class="col-lg-4 col-xs-4">
                      <div class="pull-right response">
                        <div class="i-checks">
                          <label> 
                            <input type="radio" value="true" name="a" v-model="isNewCarRegistrationDeclaredByPartner"> <i></i> Oui
                          </label>
                        </div>
                        <div class="i-checks m-l">
                          <label> 
                            <input type="radio" value="false" name="a" v-model="isNewCarRegistrationDeclaredByPartner"> <i></i> Non
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <button
                type="submit"
                class="m-b-xl btn btn-primary"
                @click="closeModal">Annuler</button>
              <button
                type="submit"
                class="m-b-xl btn btn-primary"
                @click="onConfirm">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'
  import gql from 'graphql-tag'

  export default {
    data: () => ({
      isNewCarRegistrationDeclaredByPartner: null,
      store
    }),

    computed: {
      model () {
        return store.modal.dataModel
      },

      soldMutation() {
        return gql`
          mutation {
            vehicleSold(
              orderId:"${this.model.commandId}",
              isNewCarRegistrationDeclaredByPartner: ${this.isNewCarRegistrationDeclaredByPartner}
            ) {
              result
            }
          }
        `;
      }
    },

    methods: {
      onConfirm () {
        this.$apollo.mutate({
          mutation: this.soldMutation
        }).then(() => {
          this.closeModal()
          this.showBanner('success', `Succès: le véhicule a bien été vendu !`)
        }, () => {
          this.closeModal()
          this.showBanner('danger', `Le véhicule n'a pas pu être vendu`)
        })
      }
    }
  }
</script>
